"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _vlpTableCarousel = _interopRequireDefault(require("./vlp-table-carousel.css"));
var _vlpTabWrapper = _interopRequireDefault(require("./vlp-tab-wrapper"));
var _vlpCtaWrapper = _interopRequireDefault(require("./vlp-cta-wrapper"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var getNameplateFromPathname = function getNameplateFromPathname() {
  var _window, _window$location;
  if (typeof window !== 'undefined' && (_window = window) != null && (_window$location = _window.location) != null && _window$location.pathname) {
    var pathnames = window.location.pathname.split('/').filter(Boolean);
    return pathnames[pathnames.length - 1] || '';
  }
  return '';
};
var nameplate = getNameplateFromPathname();
var VlpTableCarousel = function VlpTableCarousel(_ref) {
  var data = _ref.data;
  var ctaList = data.ctaList,
    items = data.items,
    mainHeading = data.mainHeading,
    sectionId = data.sectionId,
    disclaimerData = data.disclaimerData,
    mksSectionName = data.mksSectionName;
  var _useState = (0, _react.useState)(items[0].tabNameLabel),
    tabName = _useState[0],
    setTabName = _useState[1];
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: sectionId,
    className: _vlpTableCarousel["default"].vlpTabCarouselContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _vlpTableCarousel["default"].vlpHeadingWrapper
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: _vlpTableCarousel["default"].mainHeading
  }, mainHeading)), /*#__PURE__*/_react["default"].createElement(_vlpTabWrapper["default"], {
    items: items,
    nameplate: nameplate,
    setTabName: setTabName,
    tabName: tabName,
    disclaimerData: disclaimerData,
    mksSectionName: mksSectionName
  }), /*#__PURE__*/_react["default"].createElement(_vlpCtaWrapper["default"], {
    ctaList: ctaList,
    nameplate: nameplate,
    tabName: tabName,
    mksSectionName: mksSectionName
  }));
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market,
    language: props.language || state.Config.language
  };
};
VlpTableCarousel.resourceType = function () {
  return 'TabCarousel_1_0_0';
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(VlpTableCarousel);
exports["default"] = _default;